import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IdentificationState } from '../models/identification.state';

export const selectIdentificationState =
  createFeatureSelector<IdentificationState>('identification');

export const selectShow = createSelector(selectIdentificationState, (state) => state?.show);
